<template>
  <div class="page-container md-layout-column">

    <md-dialog-alert
      :md-active.sync="error.show"
      :md-title="error.title"
      :md-content="errorMessage(error.error)"
      md-confirm-text="Ok"/>

    <md-dialog-confirm
      :md-active.sync="dialogRemove.userID > 0"
      md-title="Удалить пользователя?"
      :md-content="dialogRemove.msg"
      md-confirm-text="Удалить"
      md-cancel-text="Отмена"
      @md-cancel="dialogRemove.userID = 0"
      @md-confirm="removeUser(dialogRemove.userID)"/>

    <md-dialog-confirm
      :md-active.sync="editPass.dialog"
      md-title="'Поменять пароль?'"
      :md-content="editPass.msg"
      md-confirm-text="Изменить"
      md-cancel-text="Отмена"
      @md-cancel="editPass.dialog = false"
      @md-confirm="changePassword()"/>

    <md-content>
      <md-table>

        <md-table-row>
          <md-table-head>ID</md-table-head>
          <md-table-head>Имя</md-table-head>
          <md-table-head>Телефон</md-table-head>
          <md-table-head>Логин</md-table-head>
          <md-table-head>Роль</md-table-head>
          <md-table-head/>
        </md-table-row>

        <md-table-row v-for="user in users">

          <md-table-cell>
            {{user.id}}
          </md-table-cell>

          <md-table-cell>
            <md-field>
              <md-icon v-if="editUserID===user.id">input</md-icon>
              <md-input v-model="user.name" :readonly="editUserID!==user.id"/>
            </md-field>
          </md-table-cell>
          <md-table-cell>
            <md-field>
              <md-icon v-if="editUserID===user.id">input</md-icon>
              <md-input v-model="user.phone" :readonly="editUserID!==user.id"/>
            </md-field>
          </md-table-cell>
          <md-table-cell>
            {{user.login}}
          </md-table-cell>
          <md-table-cell>
            <md-field>
              <md-icon v-if="editUserID===user.id">input</md-icon>
              <md-select v-model="user.role" :disabled="editUserID!==user.id">
                <md-option value="courier">Курьер</md-option>
                <md-option value="manager">Менеджер</md-option>
                <md-option value="admin">Админ</md-option>
              </md-select>
            </md-field>
          </md-table-cell>

          <md-table-cell>
            <md-button v-if="editUserID!==user.id" class="md-raised md-primary" v-on:click="editUserID = user.id">
              Изменить
            </md-button>
            <div v-else>
              <md-button class="md-raised md-accent" v-on:click="editUser(user)">Сохранить</md-button>
              <md-button class="md-raised md-primary" v-on:click="editUserID = 0">Отмена</md-button>
            </div>
          </md-table-cell>

          <md-table-cell>
            <md-button v-if="editPass.userID!==user.id" class="md-raised md-primary"
                       v-on:click="editPass.userID = user.id">Изменить пароль
            </md-button>

            <div v-else>
              <md-field>
                <md-icon>input</md-icon>
                <md-input v-model="editPass.newPass"/>
                <label>Новый пароль: </label>
              </md-field>
              <md-button class="md-raised md-accent" v-on:click="changePasswordDialog(user)">
                Сохранить
              </md-button>
              <md-button class="md-raised md-primary" v-on:click="editPass.userID = 0">
                Отмена
              </md-button>
            </div>

          </md-table-cell>

          <md-table-cell>
            <md-button class="md-raised md-accent" v-on:click="showDialogRemoveUser(user)">Удалить</md-button>
          </md-table-cell>
        </md-table-row>

      </md-table>

      <md-button class="md-raised md-primary" v-on:click="back">Назад</md-button>
      <md-button class="md-raised md-primary" v-on:click="openCreateUserDialog">Создать пользователя</md-button>

      <md-content v-if="createUserDialog">
        <form autocomplete="off">

          <md-field :class="{'md-invalid': this.newUser.name.err}">
            <label>Имя пользователя</label>
            <md-input v-model="newUser.name.val" required/>
          </md-field>

          <md-field :class="{'md-invalid': this.newUser.phone.err}">
            <label>Телефон пользователя</label>
            <span class="md-prefix">+7</span>
            <md-input v-model="phoneFormatter" maxlength="10" required/>
          </md-field>

          <md-field :class="{'md-invalid': this.newUser.login.err}">
            <label>Логин пользователя</label>
            <md-input v-model="newUser.login.val" required/>
          </md-field>

          <md-field :class="{'md-invalid': this.newUser.pass.err}">
            <label>Пароль</label>
            <md-input v-model="newUser.pass.val" type="password" required/>
          </md-field>

          <md-field :class="{'md-invalid': this.newUser.pass.err}">
            <label>Подтвердите пароль</label>
            <md-input v-model="newUser.confirm_pass.val" type="password" required/>
          </md-field>

          <md-content>
            <md-button class="md-raised md-primary" v-on:click="createUserDialog = false">Отмена</md-button>
            <md-button class="md-raised md-primary" v-on:click="addUser">Создать</md-button>
          </md-content>

        </form>
      </md-content>

    </md-content>
  </div>
</template>

<script>
  export default {
    name: "CourierManagement",
    data() {
      return {
        dialogRemove: {
          userID: 0,
          msg: "",
        },
        editUserID: 0,
        editPass: {
          userID: 0,
          user: null,
          newPass: '',
          dialog: false,
          msg: '',
        },
        newUser: {
          login: {
            val: '',
            err: false,
          },
          name: {
            val: '',
            err: false,
          },
          phone: {
            val: '',
            err: false,
          },
          pass: {
            val: '',
            err: false,
          },
          confirm_pass: {
            val: '',
          },
        },
        phoneRegX: /^(([0-9]){10})$/gm,
        createUserDialog: false,
      }
    },
    created() {
      this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
        event: 'getAllUsers',
      }))
    },
    computed: {
      phoneFormatter: {
        get: function () {
          // TODO сделать номер телефона красивым но мне лень
          return this.newUser.phone.val
        },
        // сеттер:
        set: function (newValue) {
          this.newUser.phone.val = newValue.trim();
        }
      },
      users: function () {
        return this.$store.getters.getUsers
      },
      error() {
        return this.$store.getters.getErrorByMethod('managerUsers');
      },
    },
    methods: {
      errorMessage(error) {
        return this.$store.getters.getErrorMessage(error)
      },
      back() {
        this.$router.push({path: '/'});
      },
      openCreateUserDialog() {

        this.newUser = {
          login: {
            val: '',
            err: false,
          },
          name: {
            val: '',
            err: false,
          },
          phone: {
            val: '',
            err: false,
          },
          pass: {
            val: '',
            err: false,
          },
          confirm_pass: {
            val: '',
          },
        };

        this.createUserDialog = true;
      },

      addUser() {

        this.newUser.login.err = this.newUser.login.val.trim() === '';
        this.newUser.name.err = this.newUser.name.val.trim() === '';
        this.newUser.phone.err = this.newUser.phone.val.match(this.phoneRegX) === null;
        this.newUser.pass.err = this.newUser.pass.val.trim() === '';
        this.newUser.pass.err = this.newUser.pass.val !== this.newUser.confirm_pass.val;

        if (!(this.newUser.login.err || this.newUser.name.err || this.newUser.phone.err || this.newUser.pass.err)) {
          this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
            event: 'newCourier',
            password: this.newUser.pass.val,
            user: {
              name: this.newUser.name.val,
              login: this.newUser.login.val,
              phone: this.newUser.phone.val,
            }
          }));
          this.createUserDialog = false;
        }
      },
      removeUser(id) {
        this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
          event: 'removeCourier',
          id: id,
        }));
        this.dialogRemove.userID = 0;
      },
      showDialogRemoveUser(user) {
        this.dialogRemove.userID = user.id;
        this.dialogRemove.msg = `Удалить пользователя ${user.name}`;
      },
      editUser(user) {
        this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
          event: 'editUser',
          user: user,
        }));
        this.editUserID = 0;
      },
      changePasswordDialog(user) {
        this.editPass.user = user;
        this.editPass.dialog = true;
        this.editPass.msg = "Поменять пользователю " + user.name + " пароль на " + this.editPass.newPass + " ?";
      },
      changePassword() {
        this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
          event: 'changePassCourier',
          user: this.editPass.user,
          password: this.editPass.newPass,
        }));
        this.editPass.userID = 0;
        this.editPass.newPass = ''
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CourierManagement.vue